import React from 'react';

import { ICombo, IItem, MenuObject } from '@rbi-ctg/menu';
import { PriceWithoutTax } from 'components/product-detail/price-without-tax/price-without-tax';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useMainMenuContext } from 'state/main-menu';
import { useUIContext } from 'state/ui';
import { RBIBrand, brand, getCountry } from 'utils/environment';

interface IFormatMenuPriceProps {
  menuItem: ICombo | IItem | MenuObject;
}

const getPriceForMenuObject = (
  menuItem: MenuObject,
  getPricingAndAvailability: Function,
  formatCurrencyForLocale: Function
) => {
  const pricingAndAvailability = getPricingAndAvailability(menuItem._id);

  if (!pricingAndAvailability) {
    return null;
  }

  const { price } = pricingAndAvailability;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const enableTaxLawBKAR = useFlag(LaunchDarklyFlag.ENABLE_TAX_LAW_BK_AR);

  // This is a temporary fix to achieve https://rbictg.atlassian.net/browse/IREQ-3564
  // The RBI platform should NOT be responsible for calculating prices/taxes, this should be done on the POS level

  const isBkArNationalTaxOverwriteEnabled =
    brand() === RBIBrand.BK && getCountry().toLocaleLowerCase() === 'ar' && enableTaxLawBKAR;
  if (price?.default) {
    return (
      <>
        {formatCurrencyForLocale(price.default)}
        {isBkArNationalTaxOverwriteEnabled && (
          <PriceWithoutTax totalAmount={price.default}></PriceWithoutTax>
        )}
      </>
    );
  }

  if (!price?.default && price?.min) {
    return (
      <>
        <>{formatCurrencyForLocale(price.min)}</>
        {isBkArNationalTaxOverwriteEnabled && (
          <PriceWithoutTax totalAmount={price.min}></PriceWithoutTax>
        )}
      </>
    );
  }

  return null;
};

export const FormatMenuPrice: React.FC<IFormatMenuPriceProps> = ({ menuItem }) => {
  const { getPricingAndAvailability } = useMainMenuContext();
  const { formatCurrencyForLocale } = useUIContext();
  if (!menuItem) {
    return null;
  }

  return getPriceForMenuObject(menuItem, getPricingAndAvailability, formatCurrencyForLocale);
};
